import { useEffect } from "react";
import "./toggle-switch.css";

const ToggleSwitch = ({ onChange = () => {}, checked = "false" }) => {
    return (
        <label className="toggle-switch">
            <input type="checkbox" checked={checked} onChange={onChange} />
            <div className="checkbox-ui position-relative">
                {checked ? (
                    <div className="position-absolute top-0 left-0 h-100 d-flex align-items-center" style={{padding:"0 0.15rem"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                            <title>check</title>
                            <g
                                strokeLinejoin="round"
                                strokeLinecap="round"
                                strokeWidth="2"
                                fill="none"
                                stroke="#ffffff"
                            >
                                <path d="M20 6L9 17l-5-5"></path>
                            </g>
                        </svg>
                    </div>
                ) : (
                    <div className="position-absolute top-0 end-0 h-100 d-flex align-items-center" style={{padding:"0 0.15rem"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                            <title>x</title>
                            <g
                                strokeLinejoin="round"
                                strokeLinecap="round"
                                strokeWidth="2"
                                fill="none"
                                stroke="#aaa"
                            >
                                <path d="M18 6L6 18"></path>
                                <path d="M6 6l12 12"></path>
                            </g>
                        </svg>
                    </div>
                )}
            </div>
        </label>
    );
};

export default ToggleSwitch;
